import React, { useEffect, useRef, useState } from 'react';

import { CurrentUser } from '../calendar/Calendar';
import {
  KitDocumentModel,
  MediaKitModel,
  SubmissionKitDocumentModel,
} from './components/KitModels';
import { useMedia } from 'react-use';
import { showToast } from '../shared/Toast';
import Button from '../shared/Button';
import mediaKitService from '../services/MediaKitService';
import MediaKitDocumentList from '../media_kits/MediaKitDocumentList';
import SubmissionKitMediaList from './SubmissionKitMediaList';
import submissionKitService from '../services/SubmissionKitService';
import SbProfileSelector from '../submission_boards/SbProfileSelector';
import { fromRole, SbCurrentUser, SubmissionBoardModel } from '../submission_boards/component/SbModel';
import SbProfileDetail from '../submission_boards/recipient/SbProfileDetail';
export interface SubmissionKitsViewPageProps {
  show_add_sb: boolean;
  currentUser: SbCurrentUser;
  submission_kit: any;
  project_user: any;
  project_folder_user: any;

  from: string;
  projects: any;
  project: any;
  submissionBoardModel: SubmissionBoardModel;
  user: any;
  submissionKitTags:any;
  profile: any;
}
export default function SubmissionKitsViewPage({
  show_add_sb,
  currentUser,
  submission_kit,
  project_user,
  project_folder_user,
  from,
  projects,
  project,
  submissionBoardModel,
  submissionKitTags,
  profile,
  user
}: SubmissionKitsViewPageProps) {
  const [submissionKitDocuments, setSubmissionKitDocuments] = useState<
    SubmissionKitDocumentModel[]
  >([]);
  const [showProfileDetails, setShowProfileDetails] = useState(null);
  const [submissionBoardModelSelected, setsubmissionBoardModelSelected] = useState(submissionBoardModel);

  const is400_639Screen = useMedia('(min-width: 400px) and (max-width: 639px)', false);

  // Load first page
  useEffect(() => {
    console.log('sk::winodws initial');
    // fetchSubmissionKitDocuments();
  if(submissionBoardModel == undefined || submissionBoardModel == null) {
      submissionBoardModel = {
          id: 0,
          title: '',
          multiple_hire: 0,
          sb_status: '',
          project_id: 0,
          created_by: 0,
          created_at: '',
          expire_at: '',
          total_profiles: 0,
          total_profiles_pending: 0,
          total_profiles_onboard: 0,
          total_profiles_rejected: 0,
          request:0
      };
    }
    submissionBoardModel.submission_kit_tags = submissionKitTags;
    setsubmissionBoardModelSelected(submissionBoardModel)
    setShowProfileDetails(profile);
  }, [profile]);

  const fetchSubmissionKitDocuments = async () => {
    try {
      const resp = await submissionKitService.getSubmissionKitDocumentById(submission_kit.uuid);
      console.log(resp);
      if (resp && 'submission_kit_documents' in resp) {
        let _submission_kit = {...submission_kit, submission_kit_documents: resp.submission_kit_documents }
        // setShowProfileDetails({...currentUser, ...{submission_kit: _submission_kit}})
        if(submissionBoardModel == undefined) {
          submissionBoardModel = {
             id: 0,
              title: '',
              multiple_hire: 0,
              sb_status: '',
              project_id: 0,
              created_by: 0,
              created_at: '',
              expire_at: '',
              total_profiles: 0,
              total_profiles_pending: 0,
              total_profiles_onboard: 0,
              total_profiles_rejected: 0,
              request:0
          };
        }
        submissionBoardModel.submission_kit_tags = submissionKitTags;

        setSubmissionKitDocuments(resp.submission_kit_documents);
      }
    } catch (error) {
      showToast('Error while fetching submission kits.', 'danger');
    } finally {
      console.log('sk: fetchMediaKits Out');
      console.log('sk: isLoading false');
    }
  };

  return (
    <div className="w-full flex flex-col flex-1 mx-auto ">
      {/* <div className="w-full px-4 py-2 mx-auto">
        <div className="flex items-center hidden lg:block w-24">
          <a href="javascript:history.back()">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="#9CA3AF"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </a>
        </div>
      </div> */}

      <div className="w-full px-4 py-4 mx-auto">
        <div className="flex flex-col relative w-full relative">
          {/* top filter bar */}
          <div
            style={{
              position: 'sticky',
              top: '0px',
              zIndex: 2,
            }}
          >
            {/* {show_add_sb && submissionBoardModelSelected && (
              <div className="scrollable-content flex overflow-y-autojustify-items-center px-2 py-1">
                <SbProfileSelector
                  from={from}
                  projects={projects}
                  project={project}
                  submissionBoardModel={submissionBoardModelSelected}
                  currentUser={currentUser}
                  alreadyInSb={false}
                  user={{
                    id: submission_kit.user_id,
                  }}
                ></SbProfileSelector>
              </div>
            )} */}

            <div className="scrollable-content overflow-y-autojustify-items-center px-2 py-1 flex flex-col">

              <div className={'font-semibold text-gray-900 text-3xl leading-9'}>
                Submission Kit
              </div>
              <hr className="mt-5 mb-8" />
              <div className="container my-5 mx-auto flex w-full flex-col items-end">
                <div 
                className={(is400_639Screen ? 'px-0' : 'p-0') + ' w-full flex justify-center'}
                  // className="relative flex h-full w-full flex-col gap-2-1 pt-5 pb-10 bg-white shadow-xl-0-19-40-8 rounded-md"
                  //  style={{
                  //   maxWidth: '71.25rem',
                  //   maxHeight: '50rem',
                  // }}
                  >
                     {showProfileDetails && submissionBoardModelSelected && <SbProfileDetail
                              currentUser={currentUser}
                              project={project}
                              submissionBoardModel={submissionBoardModelSelected}
                              profileUser={showProfileDetails}
                              fromScreen={fromRole.PROFILE_VIEWER}
                              dialogCloseHandler={() => {
                                // setShowProfileDetails(null);
                              }}
                              refreshSubmissionBoard={() => {
                                // if (refreshSubmissionBoard) {
                                //   refreshSubmissionBoard();
                                // }
                              }}
                              prevNextProfile={async (value: number) => {
                              
                                return false;
                              }}
                            ></SbProfileDetail>
}
                  {/* <SubmissionKitMediaList
                    from="view"
                    submissionKitDocuments={submissionKitDocuments}
                    addToSubmissionKit={async function (
                      kit_document: any,
                      tag: string
                    ): Promise<boolean> {
                      return true;
                    }}
                    removeFromSubmissionKit={async function (
                      submissionKitDocument: SubmissionKitDocumentModel
                    ): Promise<boolean> {
                      return true;
                    }}
                    submissionKitTags={submissionKitTags}
                  ></SubmissionKitMediaList> */}
                </div>
              </div>
            </div>
          </div>
          {/* top filter bar */}
        </div>
      </div>
    </div>
  );
}
